import { firebase } from '../firebase/firebase';
import { setPlaceUsers } from './place';

const isActiveUserFunction = firebase.functions().httpsCallable('httpsUtilsIsActiveUser');
const getUserDataFunction = firebase.functions().httpsCallable('httpsUtilsGetUserData');

export var isActiveUser = (userUid) => {
  return () => isActiveUserFunction(userUid);
};

export var getClanName = (clanUid) => {
  return (dispatch, getState) => {
    const clans = getState().place.clans;
    return clans[clanUid];
  };
};

export const getPlaceName = (placeUid) => {
  return (dispatch) => {
    return firebase.database().ref(`places/${placeUid}/name`).once('value').then((snapshot) => {
      return snapshot.val();
    });
  };
};

export var getUser = (userUid) => {
  return (dispatch, getState) => {
    let users = getState().place.users;
    return new Promise((resolve, reject) => {
      if (users[userUid]) {
        resolve(users[userUid]);  // fulfilled successfully
      } else {
        getUserDataFunction({userUid}).then((snap) => {
          if (snap.data) {
            const { lastName, name, phoneNumber } = snap.data;
            const user = { lastName, name, phoneNumber };
            users[userUid] = user;
            dispatch(setPlaceUsers(users));
            resolve(user);
          } else {
            reject(`User uid not found ${userUid}`);
          }
        });
      };
    });
  };
};

export var getUserNameByPhoneNumber = (phoneNumber) => {
  return (dispatch, getState) => {
    let users = getState().place.users;
    let userUid = undefined;
    Object.keys(users).map((uid) => {
      if (users[uid].phoneNumber == phoneNumber) {
        userUid = uid;
      }
    });
    if (users[userUid]) {
      return `${users[userUid].name} ${users[userUid].lastName}`;
    } else {
      return null;
    }

  };
};

export var getUserFullName = (userUid) => {
  return (dispatch, getState) => {
    const users = getState().place.users;
    const usersQueue = getState().place.usersQueue;
    if (users[userUid]) {
      const name = users[userUid].name;
      const lastName = users[userUid].lastName;
      return(`${name} ${lastName}`);
    } else if (usersQueue[userUid]) {
      return(usersQueue[userUid].phoneNumber);
    } else {
      console.log(userUid, 'not found');
      return null;
    }
  };
};

export var getUserPhoneNumber = (userUid) => {
  return (dispatch, getState) => {
    const users = getState().place.users;
    const usersQueue = getState().place.usersQueue;
    if (users[userUid]) {
      return(users[userUid].phoneNumber);
    } else if (usersQueue[userUid]) {
      return(usersQueue[userUid].phoneNumber);
    } else {
      return null;
    }
  };
};
